import { render, staticRenderFns } from "./LeftSecondSecond.vue?vue&type=template&id=2b02145b&scoped=true"
import script from "./LeftSecondSecond.vue?vue&type=script&lang=js"
export * from "./LeftSecondSecond.vue?vue&type=script&lang=js"
import style0 from "./LeftSecondSecond.vue?vue&type=style&index=0&id=2b02145b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02145b",
  null
  
)

export default component.exports